import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ClaimAction {
  SUBMIT_CLAIM = "SUBMIT_CLAIM",
  CLEAN_UP = "CLEAN_UP",
}

export type ClaimState = Readonly<{}>;

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ClaimScope = "claim";
